import React, { useEffect, useRef, useState } from "react";
import logo from "../../assets/images/logo.png";
import logo2 from "../../assets/images/logo2.png";
import defaultUser from "../../assets/images/Default_user_image.png";
import { SearchOutlined } from "@mui/icons-material";
import { Link, NavLink } from "react-router-dom";
import useLocalStorage from "use-local-storage";
import Toggle from "../../Toggle";
import HomeSharpIcon from "@mui/icons-material/HomeSharp";
import WorkSharpIcon from "@mui/icons-material/WorkSharp";
import axios from "../.././API/axios";
import GobalSearch from "../../khojpages/GlobalSearch/GobalSearch";
NonLoginHeader.propTypes = {};

function NonLoginHeader({ clname = "", handleMobile }) {
  const [isDark, setIsDark] = useLocalStorage("isDark", false);
  const dropdownRef1 = useRef(null);
  const [scroll, setScroll] = useState(0);

  useEffect(() => {
    document.addEventListener("scroll", () => {
      const scrollCheck = window.scrollY > 100;
      if (scrollCheck !== scroll) {
        setScroll(scrollCheck);
      }
    });
  }, []);
  const [inputValue, setInputValue] = useState("");
  const [searchUser, setSearchUser] = useState([]);
  const [searchComp, setSearchComp] = useState([]);
  const [searchJob, setSearchJob] = useState([]);
  const [options, setOptions] = useState([]);
  const [page, setPage] = useState(1);
  const [searchPost, setSearchPost] = useState([]);

  const addOptions = () => {
    axios
      .get(`/Feature/GlobalSearch?search=${inputValue}`)
      .then((response) => {
        let data = response.data.data;
        data = data.map((item) => {
          const [type, followers] = item.type.split(",");
          return {
            ...item,
            type,
            followers: parseInt(followers, 10),
          };
        });
        const addUniqueItems = (data, type) => {
          const uniqueItems = data.filter((item) => item.type === type);
          return uniqueItems;
        };
        setSearchUser(addUniqueItems(data, "User"));
        setSearchComp(addUniqueItems(data, "Company"));
        setSearchJob(addUniqueItems(data, "Job"));
        setSearchPost(addUniqueItems(data, "Post"));
        setOptions((prev) => {
          const postSet = new Set(prev.map((post) => post.id));
          const uniqueNewPosts = data.filter((post) => !postSet.has(post.id));
          return [...prev, ...uniqueNewPosts];
        });
      })
      .catch((error) => {
        console.log("Error:", error);
      });
  };

  useEffect(() => {
    if (inputValue) {
      addOptions(page);
    } else {
      setOptions([]);
      setSearchUser([]);
      setSearchComp([]);
      setSearchJob([]);
      setSearchPost([]);
    }
  }, [inputValue, page]);

  const handleInfiniteScroll = () => {
    const { scrollTop, clientHeight, scrollHeight } = dropdownRef1.current;
    if (scrollTop + clientHeight >= scrollHeight - 1) {
      setPage((prev) => prev + 1);
    }
  };

  useEffect(() => {
    if (dropdownRef1.current) {
      dropdownRef1.current.addEventListener("scroll", handleInfiniteScroll);
      return () =>
        dropdownRef1.current.removeEventListener(
          "scroll",
          handleInfiniteScroll
        );
    }
  }, [dropdownRef1]);

  const searchContainerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef1.current &&
        !dropdownRef1.current.contains(event.target) &&
        searchContainerRef.current &&
        !searchContainerRef.current.contains(event.target)
      ) {
        setOptions([]);
        setInputValue("");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  return (
    // <header id="header" className="header header-default container header-fixed">
    <header
      id="header"
      className={`header pt-3 loginkhojHeader header-default`}
    >
      <div className="px-4 ct2">
        <div className="row">
          <div className="col-md-12">
            <div className="sticky-area-wrap">
              <div className="header-ct-left">
                {isDark ? (
                  <div id="logo" className="logo">
                    <Link to="/Home">
                      <img
                        className="site-logo"
                        id="trans-logo"
                        src={logo2}
                        alt="Image"
                      />
                    </Link>
                  </div>
                ) : (
                  <div id="logo" className="logo">
                    <Link to="/">
                      <img
                        className="site-logo"
                        id="trans-logo"
                        src={logo}
                        alt="Image"
                      />
                    </Link>
                  </div>
                )}
              </div>

              {/* Search container */}

              <div className="form-group-1 khojSearch d-flex align-items-center">
                <GobalSearch />
                {/* <div className="search-container">
                  <SearchOutlined className="searchIcon" />

                  <div className="search-input-container">
                    <input
                      type="text"
                      className="input-filter-search"
                      placeholder="Search"
                      value={inputValue}
                      onChange={(e) => {
                        setInputValue(e.target.value);
                      }}
                    />
                    {(options.length > 0 || inputValue !== "") && (
                      <ul className="suggestions-dropdown" ref={dropdownRef1}>
                        {searchUser.length > 0 && (
                          <div style={{ margin: "4px 16px" }}>
                            <p style={{ margin: "0", fontWeight: "800" }}>
                              People
                            </p>
                          </div>
                        )}
                        {searchUser.map((item, index) => (
                          <Link to={`/User/${item?.id}`} key={index}>
                            <li
                              className="suggestion-item d-flex"
                              onClick={() => {
                                setOptions([]);
                                setInputValue("");
                              }}
                            >
                              <img
                                src={item?.image}
                                alt=""
                                width={30}
                                height={30}
                                style={{ borderRadius: "50px" }}
                              />
                              <div>
                                <p className="ms-2">{item?.title}</p>
                                <p className="ms-2 f-12">
                                  {item?.additionalInfo}
                                </p>
                                <p className="ms-2 f-12">{item?.description}</p>
                                <p className="ms-2 f-12">
                                  {item?.followers} followers
                                </p>
                              </div>
                            </li>
                          </Link>
                        ))}
                        {searchComp.length > 0 && (
                          <div style={{ margin: "4px 16px" }}>
                            <p style={{ margin: "0", fontWeight: "800" }}>
                              Company
                            </p>
                          </div>
                        )}
                        {searchComp.map((item, index) => (
                          <Link to={`/Company/${item?.id}`} key={index}>
                            <li
                              className="suggestion-item d-flex"
                              onClick={() => {
                                setOptions([]);
                                setInputValue("");
                              }}
                            >
                              <img
                                src={item?.image}
                                alt=""
                                width={30}
                                height={30}
                                style={{ borderRadius: "50px" }}
                              />
                              <div>
                                <p className="ms-2">{item?.title}</p>
                                <p className="ms-2 f-12">
                                  {item?.additionalInfo}
                                </p>
                                <p className="ms-2 f-12">{item?.description}</p>
                                <p className="ms-2 f-12">
                                  {item?.followers} followers
                                </p>
                              </div>
                            </li>
                          </Link>
                        ))}
                        {searchJob.length > 0 && (
                          <div style={{ margin: "4px 16px" }}>
                            <p
                              style={{
                                margin: "0",
                                fontWeight: "600",
                                fontSize: "20px",
                              }}
                              className="d-flex"
                            >
                              Job
                            </p>
                          </div>
                        )}
                        {searchJob.map((item, index) => (
                          <Link to={`/JobDetail/${item?.id}`} key={index}>
                            <li
                              className="suggestion-item d-flex"
                              onClick={() => {
                                setOptions([]);
                                setInputValue("");
                              }}
                            >
                              <div className="search-user-img">
                                <img
                                  src={defaultUser}
                                  alt=""
                                  width={30}
                                  height={30}
                                  style={{ borderRadius: "50px" }}
                                />
                              </div>

                              <div>
                                <p className="ms-2 mb-0">{item?.title}</p>
                                <p className="ms-2 f-12">
                                  {item?.additionalInfo}
                                </p>
                                <p className="ms-2 f-12">{item?.description}</p>
                               
                              </div>
                            </li>
                          </Link>
                        ))}
                        {searchPost.length > 0 && (
                          <div style={{ margin: "4px 16px" }}>
                            <p style={{ margin: "0", fontWeight: "800" }}>
                              Post
                            </p>
                          </div>
                        )}
                        {searchPost.map((item, index) => (
                          <Link to={`/Post/${item?.id}`} key={index}>
                            <li
                              className="suggestion-item d-flex"
                              onClick={() => {
                                setOptions([]);
                                setInputValue("");
                              }}
                            >
                              <img
                                src={item?.image}
                                alt=""
                                width={30}
                                height={30}
                                style={{ borderRadius: "50px" }}
                              />
                              <div>
                                <p className="ms-2">{item?.title}</p>
                                <p className="ms-2 f-12">
                                  {item?.additionalInfo}
                                </p>
                                <p className="ms-2 f-12">{item?.description}</p>
                                <p className="ms-2 f-12">
                                  {item?.followers} followers
                                </p>
                              </div>
                            </li>
                          </Link>
                        ))}
                      </ul>
                    )}
                  </div>
                </div> */}
              </div>

              {/******************           Search closed       ***********************/}

              <div className="header-ct-center">
                <div className="nav-wrap">
                  <nav id="main-nav" className="main-nav">
                    <ul
                      id="menu-primary-menu"
                      className={`menu mb-2 ${clname}`}
                    >
                      <li className="menu-item  sub1">
                        <HomeSharpIcon />
                        <NavLink to="/Home">Home</NavLink>
                      </li>
                      <li className="menu-item subjob">
                        <WorkSharpIcon />
                        <NavLink to="/SearchJobs">Jobs</NavLink>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
              <div className="header-ct-right">
                <Toggle
                  isChecked={isDark}
                  handleChange={() => setIsDark(!isDark)}
                  className="desktopToggle"
                />
                <div className="khojPrimaryBtn ms-3">
                  <Link to="/login" className="">
                    Login
                  </Link>
                </div>
                <div className="form-group-4 ms-3">
                  <div className="khojSecondaryBtn">
                    <Link to="/register" className="">
                      Register
                    </Link>
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-center">
                <div className="ms-auto mobileToggle me-2">
                  <Toggle
                    isChecked={isDark}
                    handleChange={() => setIsDark(!isDark)}
                  />
                </div>
                <div className="nav-filter" onClick={handleMobile}>
                  <div className="nav-mobile">
                    <span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default NonLoginHeader;
